import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as SettingsSelectors from '../../../../selectors/settings';

import EmailsInput from '../EmailsInput';
import TeamMemberInput from '../TeamMemberInput';

export function StatelessInvitePeople({ isTeamCollaboration, ...otherProps }) {
    return isTeamCollaboration ? (
        <TeamMemberInput {...otherProps}/>
    ) : (
        <EmailsInput {...otherProps}/>
    );
}

StatelessInvitePeople.propTypes = {
    isTeamCollaboration: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
    isTeamCollaboration: SettingsSelectors.isTeamCollaboration(state)
});

export default connect(mapStateToProps)(StatelessInvitePeople);
